import { useFlipperFlag } from './useFlipperFlag'
import { useIsOnboardingRedesign } from './useIsOnboardingRedesign'
import { useIsPioneerStarterOrGrowth } from './useIsPioneerStarterOrGrowth'

export const useIsVisualStylesOnboarding = () => {
  const isOnboardingRedesign = useIsOnboardingRedesign()
  const isVisualStylesOnboardingFlag = useFlipperFlag('credits_styles_videos')
  const planVariant = useIsPioneerStarterOrGrowth()
  const isStarterOrGrowth = ['starter', 'growth'].includes(planVariant)

  return isOnboardingRedesign && isVisualStylesOnboardingFlag && isStarterOrGrowth
}
